import React, { useEffect, useState } from 'react';

export default () => {
  const [message, setMessage] = useState('');
  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const message = params.get('message');
    if (message) {
      setMessage(message);
      window.history.replaceState('', '/', window.location.pathname);
    }
  }, []);

  return (
    <div className={`modal ${message && 'open'}`}>
      <article className="content-wrapper mx-10 w-full md:w-[60%] md:mx-0 lg:w-[40%]">
        <button
          className="close close__button"
          onClick={() => {
            setMessage('');
          }}></button>
        <header className="modal-header">
          <h2>Чекаємо на вас!</h2>
        </header>
        <>
          <div className="modal__content-block text-start w-full whitespace-pre-line">
            {decodeURI(message)}
          </div>
          <button
            className="action modal-footer__button w-full mt-8"
            onClick={() => {
              setMessage('');
            }}>
            Закрити
          </button>
        </>
      </article>
    </div>
  );
};
